import { useContext, useEffect } from "react";
import { MarkerOptions } from "mapbox-gl";
//@ts-ignore
import Mazemap from "@itpi/mazemap";
import "@itpi/mazemap/mazemap.min.css";
import {
  Box,
  BoxProps,
  useId,
  useTheme,
} from "@chakra-ui/react";
import { MapContext } from "../context/map.context";
import { css, Global } from "@emotion/react";

export type MapPin = MarkerOptions & {
  lat: number;
  lng: number;
  zLevel?: number;
  onClick?: () => void;
  glyph?: string;
  shape?: string;
  size?: number;
};

export const defaultLocation = {
  pitch: 0,
  bearing: 0,
  zoom: 14.5,
  center: {
    lng: -2.785908,
    lat: 54.008355,
  },
};

const Map = (boxProps: BoxProps) => {
  const mapId = useId();
  const { map, setMap, pins } = useContext(MapContext);
  const theme = useTheme();

  // @ts-ignore
  window.Mazemap = Mazemap;

  useEffect(() => {
    const mazemap = new Mazemap.Map({
      container: mapId,
      campuses: 341,
      zLevelControl: false,
      ...defaultLocation,
    });

    mazemap.on("load", () => {
      const floorBar = new Mazemap.ZLevelBarControl();
      mazemap.addControl(floorBar, "top-left");
    });

    setMap(mazemap);
  }, [mapId, setMap]);

  useEffect(() => {
    if (map && pins) {
      const markers = pins.map((pin) => {
        const { lat, lng, onClick, ...config } = pin;
        const marker = new Mazemap.MazeMarker({
          color: theme.colors?.["lancsRed"]?.["300"],
          ...config,
        })
          .setLngLat({ lat, lng })
          .addTo(map);
        marker.on("click", onClick);
        return marker;
      });
      return () => markers.forEach((m) => m.remove());
    }
  }, [pins, map, theme.colors]);

  return (
    <>
      <Global
        styles={css`
          .mapboxgl-ctrl-bottom-left {
            z-index: 100;
          }

          .mazemap-control-zlevel-bar {
            color: black;
          }
        `}
      />
      <Box
        id={mapId}
        w="full"
        h="full"
        {...boxProps}
      />
    </>
  );
};

export default Map;
